export class FileManagerConfig {
  origin: () => string;
}
